{
    "header": "הדפס דפים מיוחדים",
    "smallTable": "טבלת יתרות",
    "alyot": "טבלת עליות"

}